import { format, formatDistance } from 'date-fns'


export default {
     install(Vue) {
         Vue.filter('date', (date) => format(date, 'DD/MM/YYYY'));
         Vue.filter('dateShort', (date) => format(date, 'DD/MM/YY'));
     }
}